var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-banner',{staticClass:"banner mt-5",attrs:{"single-line":"","transition":"slide-y-transition"}},[_c('v-avatar',{attrs:{"slot":"icon"},slot:"icon"},[_c('v-icon',{attrs:{"color":"red","large":""}},[_vm._v("warning")])],1),_vm._v(" "),_c('div',{staticClass:"text-start"},[_vm._v(_vm._s(this.errorMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }